const URL = process.env.VUE_APP_API;
export const IMG = process.env.VUE_APP_S3_URL;

export const ROUTES = {
    //SECURITY
    LOGIN: () => `${URL}/user/login`,
    GET_PAGE: () => `${URL}/product/find`,
    //PRODUCT
    GET_PRODUCT: () => `${URL}/product/findOne`,
    GET_PRODUCTS: () => `${URL}/product/all`,
    GET_LISTS: () => `${URL}/product/getAllLists`,
    GET_COLORS: () => `${URL}/product/colors`,
    UPDATE_COLOR: () => `${URL}/product/updateColor`,
    MERGE_COLOR: () => `${URL}/product/mergeColors`,
    DELETE_COLOR: () => `${URL}/product/deleteColor`,
    GET_COLOR_PRODUCTS: () => `${URL}/product/getColorProducts`,
    CREATE_VARIANT: () => `${URL}/product/variant`,
    UPDATE_VARIANT: () => `${URL}/product/updateVariant`,
    CREATE_PRODUCT: () => `${URL}/product/create`,
    UPDATE_PRODUCT: () => `${URL}/product/update`,
    GET_VARIANT: (id) => `${URL}/product/getVariant/${id}`,
    DELETE_VARIANT: () => `${URL}/product/deleteVariant`,
    DUPLICATE_VARIANT: () => `${URL}/product/duplicate`,
    GET_TAGS: () => `${URL}/product/getSpecificTag`,
    MERGE_TAGS: () => `${URL}/product/mergeTags`,
    GET_TAG_PARENTS: (id) => `${URL}/product/getTagParents/${id}`,
    GET_TAG_PRODUCTS: (id) => `${URL}/product/getTagProducts/${id}`,
    CREATE_TAG: () => `${URL}/product/tag`,
    CREATE_COLOR: () => `${URL}/product/color`,
    UPDATE_TAG: () => `${URL}/product/updateTag`,
    REMOVE_TAG: () => `${URL}/product/removeTag`,
    GET_PRODUCT_VARIANTS: () => `${URL}/product/getProductVariant`,
    UPLOAD_IMAGE: () => `${URL}/product/uploadImage`,
    UPLOAD_IMAGE_FROM_INTERNET: () => `${URL}/product/uploadImageFromInternet`,
    //BRAND
    CREATE_BRAND: () => `${URL}/brand/`,
    GET_BRANDS: () =>`${URL}/brand/all`,
    GET_BRAND_PRODUCTS: () =>`${URL}/brand/products`,
    GET_COLLABORATOR_PRODUCTS: () =>`${URL}/brand/collaborators/products`,
    DELETE_BRAND: () => `${URL}/brand/delete`,
    GET_OUTDATED: () =>`${URL}/marketplace/outdated`,
    CREATE_MARKETPLACES: () => `${URL}/marketplace/`,
    GET_MARKETPLACES: () =>`${URL}/marketplace/all`,
    GET_MARKETPLACE_PRODUCTS: () =>`${URL}/marketplace/products`,
    DELETE_MARKETPLACE: () => `${URL}/marketplace/delete`,
    //USER
    CREATE_USER: () => `${URL}/user`,
    USER: (id) => `${URL}/user/${id}`,
    LIST_USER: () => `${URL}/user/list`,
    RESET_PASSWORD: () => `${URL}/user/resetPassword`,
    RESET_PASSWORD_CODE: () => `${URL}/user/requestCodeLostPassword`,
    //BOOKMARKS (admin)
    GET_BOOKMARKS: () => `${URL}/bookmark`,
    DELETE_BOOKMARK: (id) => `${URL}/bookmark/${id}`,
    CREATE_BOOKMARK: () => `${URL}/bookmark/create`,
};
